const NavbarItemList = [
  { id: 1, text: "about chatbot" , link : "/about-chatbot" },
  { id: 2, text: "Solutions" , link : "/solutions" },
  // { id: 3, text: "Resources" , link : "/r" },
  { id: 4, text: "Frequent topics" , link : "/frequent-topic" },
  // { id: 5, text: "Privacy" , link : "/p" },
  { id: 6, text: "Pricing" , link : "/pricing" },
];

export default NavbarItemList